export function getSocketURL() {
	const isDev = process.env.NODE_ENV === 'development';

	let hostname = '';
	// const wsEndpoint = '/wsbridge/v1/game/orbital.kyotoclassic';
	const wsEndpoint = '/wsbridge/v1/game/orbital.miamiclassic';

	if (isDev) {
		hostname = 'test.orbitalgaming.io';
		// hostname = '192.168.88.68:10045';
	} else {
		hostname = window.location.hostname;
	}

	return `wss://${hostname}${wsEndpoint}`;
}
